import React from 'react';

const TermosTexto = () => (
  <div>
    <p>
      O usuário ("USUÁRIO"), ao instalar, ativar, utilizar ou realizar qualquer
      operação com os robôs da Quantum Trades dentro da plataforma MetaTrader 5 (MT5),
      declara estar ciente e de acordo com os seguintes termos:
    </p>

    <p>
      <strong>1 –</strong> O USUÁRIO utiliza os sistemas por livre vontade,
      autorizando o tratamento dos dados necessários ao funcionamento,
      estatísticas internas, segurança, registro de logs e melhoria contínua do sistema.
    </p>

    <p>
      <strong>2 –</strong> O USUÁRIO declara compreender plenamente o
      funcionamento dos robôs, bem como todos os riscos financeiros envolvidos
      em operações automatizadas.
    </p>

    <p>
      <strong>3 –</strong> Toda configuração de volume, risco, reentradas,
      distâncias, metas, stops, correlações e parâmetros operacionais é de
      responsabilidade exclusiva do USUÁRIO.
    </p>

    <p>
      <strong>4 –</strong> A Quantum Trades não garante lucros, não presta
      consultoria financeira, não sugere estratégias e não se responsabiliza por
      perdas decorrentes de configurações inadequadas, falhas técnicas,
      volatilidade, slippage, spreads, stop outs, desconexões ou qualquer outro
      evento de mercado.
    </p>

    <p>
      <strong>5 –</strong> Os robôs da Quantum Trades operam exclusivamente sobre a
      estrutura do MetaTrader 5, desenvolvido pela MetaQuotes. Assim, a Quantum Trades
      não possui responsabilidade por erros, instabilidades ou limitações da plataforma MT5.
    </p>

    <p>
      <strong>6 –</strong> O USUÁRIO reconhece que operações no mercado Forex,
      ouro, índices e demais derivativos envolvem riscos significativos, podendo
      resultar em perdas superiores ao capital investido.
    </p>

    <p>
      <strong>7 –</strong> Resultados exibidos em backtests, demonstrações,
      portfólios e simulações são apenas estimativas e{' '}
      <strong>não representam garantia de desempenho futuro.</strong>
    </p>

    <p>
      <strong>8 –</strong> É proibida a distribuição, cópia, venda,
      compartilhamento ou uso dos robôs em qualquer sistema de terceiros sem
      autorização expressa da Quantum Trades.
    </p>

    <p>
      <strong>9 –</strong> O USUÁRIO concorda que o software executará ordens
      automaticamente, seguindo regras configuradas por ele, isentando a Quantum Trades
      de responsabilidade sobre decisões geradas pelo algoritmo.
    </p>

    <p>
      <strong>10 –</strong> O USUÁRIO concorda que erros, interrupções,
      configurações incorretas, condições extremas de mercado, gaps, spreads e
      latência podem gerar perdas, e que essas perdas são de sua total responsabilidade.
    </p>

    <p>
      <strong>11 –</strong> O uso dos robôs implica aceitação integral destes
      termos. Caso o USUÁRIO discorde de qualquer item, deve interromper
      imediatamente o uso.
    </p>

    <p>
      <strong>12 – Direito de arrependimento (7 dias):</strong> o USUÁRIO poderá
      solicitar a devolução integral dos valores pagos pela contratação em até{' '}
      <strong>7 (sete) dias corridos</strong> a contar da data da primeira contratação.
      Após esse prazo, não haverá reembolso, ainda que o sistema deixe de ser utilizado.
    </p>
  </div>
);

export default TermosTexto;
